import { render, staticRenderFns } from "./RightView.vue?vue&type=template&id=2e8784d4&scoped=true"
import script from "./RightView.vue?vue&type=script&lang=js"
export * from "./RightView.vue?vue&type=script&lang=js"
import style0 from "./RightView.vue?vue&type=style&index=0&id=2e8784d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8784d4",
  null
  
)

export default component.exports